import { Box, Divider, Link, Typography } from "@mui/material";

export default function Footer() {
  return (
    <Box margin="auto" textAlign="center">
      <Divider sx={{ width: 60, mx: "auto", my: 3 }} />
      <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
        Нотариална камара на Република България
      </Typography>
      <Typography variant="caption" align="center" color="textSecondary">
        {new Date().getFullYear() + " © "}
        <Link color="inherit" target="_blank" href="https://www.notary-chamber.bg/">
          Всички права запазени
        </Link>
      </Typography>
      <Divider sx={{ width: 60, mx: "auto", my: 3 }} />
    </Box>
  );
}
